import React from 'react'
import './NavBar.css'

export default function Navbar() {
  return (
    <nav className=''>
        <h1 className='nav-title'>ALGORITHM VISUALIZER</h1>
    </nav>
  )
}
